/**
 * URL utility functions for external services
 * These functions access webpack DefinePlugin injected variables
 */

/**
 * Get the new admin URL from webpack DefinePlugin
 * NEW_ADMIN_URL is injected at build time
 *
 * @throws {Error} If NEW_ADMIN_URL is not defined
 */
export function getNewAdminUrl(): string {
  // @ts-ignore - webpack DefinePlugin injects this at build time
  if (typeof NEW_ADMIN_URL === 'undefined' || !NEW_ADMIN_URL) {
    throw new Error(
      'NEW_ADMIN_URL is not defined. This should be set via webpack DefinePlugin.'
    );
  }
  // @ts-ignore
  return NEW_ADMIN_URL;
}

/**
 * Get the MSI (Sales Copilot) URL
 * MSI_URL might be defined via environment variable
 *
 * @returns The MSI URL
 */
export function getMsiUrl(): string {
  return 'https://msi.hginsights.com/';
}

/**
 * Returns the Market Analyzer base URL based on the current environment
 * - Production: https://market.hginsights.com
 * - Staging/Dev: https://market-staging.hginsights.info
 */
export function getMarketUrl(): string {
  return ENVIRONMENT === 'prod'
    ? 'https://market.hginsights.com'
    : 'https://market-staging.hginsights.info';
}

/**
 * Returns the App base URL based on the current environment
 * - Production: https://app.hginsights.com
 * - Staging/Dev: https://app-staging.hginsights.info
 */
export function getAppBaseUrl(): string {
  return ENVIRONMENT === 'prod'
    ? 'https://app.hginsights.com'
    : 'https://app-staging.hginsights.info';
}

/**
 * Returns the AI Sales Copilot base URL based on the current environment
 * - Production: https://hsi.hginsights.com
 * - Staging/Dev: https://hsi-staging.hginsights.info
 */
export function getAiCopilotUrl(): string {
  return ENVIRONMENT === 'prod'
    ? 'https://hsi.hginsights.com'
    : 'https://hsi-staging.hginsights.info';
}

/**
 * Append SuperKudu impersonation params to a Market Analyzer URL when the
 * caller is operating cross-tenant. Mirrors mk-admin-app's
 * `buildMarketAnalyzerUrl` so the receiving app sees the same query keys.
 */
export function buildMarketAnalyzerUrl(
  baseUrl: string,
  tenantId: string,
  shouldAddImpersonationParams: boolean
): string {
  if (!baseUrl || baseUrl === '#') return '#';
  if (!shouldAddImpersonationParams) return baseUrl;

  try {
    const url = new URL(baseUrl);
    url.searchParams.set('from', 'admin');
    url.searchParams.set('impersonationTenantId', tenantId);
    return url.toString();
  } catch (_error) {
    return baseUrl;
  }
}
